import type { QueryClient } from "@tanstack/react-query";
import { type LoaderFunctionArgs, defer } from "react-router-dom";
import { getOrganizationOptions } from "../../../services";
import { organizationProfilesQueryOptions } from "../../../services/organtization/get-organization-profiles";

export const buildMembersLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    if (!params.organizationId) throw new Error("Organization ID is required");

    // Kick off profiles fetch in the background — doesn't block navigation
    queryClient.ensureQueryData(organizationProfilesQueryOptions(params.organizationId));

    return defer({
      organization: queryClient.ensureQueryData(getOrganizationOptions(params.organizationId)),
    });
  };
